import React from 'react'
import PropTypes from 'prop-types'
import { Copy } from '@elparking/components'
import { FormattedMessage } from 'react-intl'
import { LoginContent } from './ui/Login'

const Container = ({ children }) => <div>
    <Copy padding='0 0 16px 0 ' size='xLarge' fontWeight='book'>
        <FormattedMessage defaultMessage='¿Ya tienes una cuenta con nosotros?' />
    </Copy>
    <LoginContent>
        <Copy padding='0 0 8px 0' size='xxSmall' fontWeight='book' transform='uppercase'>
            <FormattedMessage defaultMessage='Inicia sesión' />
        </Copy>
        <Copy padding='0 0 16px 0' size='xxSmall' fontWeight='regular' color='darkMain'>
            <FormattedMessage defaultMessage='Para que el proceso sea más rápido inicia sesión' />
        </Copy>
        { children }
    </LoginContent>
</div>

Container.propTypes = {
    children: PropTypes.node,
}

export default Container
